import { render, staticRenderFns } from "./applyInfoForm.vue?vue&type=template&id=62d60bb0&scoped=true"
import script from "./applyInfoForm.vue?vue&type=script&lang=js"
export * from "./applyInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d60bb0",
  null
  
)

export default component.exports